import { cn } from '@/lib/utils';
import React from 'react';

interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ title, description, align = 'left', className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'mb-16',
        align === 'center' ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl',
        className
      )}
      {...props}
    >
      <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-lg text-muted-foreground leading-relaxed">
          {description}
        </p>
      )}
    </div>
  )
);
SectionHeader.displayName = 'SectionHeader';

export { SectionHeader };
